import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import { createPasswordVisibilitySlotProps } from "./registrationPasswordSlotProps";

export function RegistrationPasswordField({ type: _ignoredType, slotProps: _ignoredSlotProps, ...textFieldProps }) {
  const [visible, setVisible] = useState(false);

  return (
    <TextField
      {...textFieldProps}
      type={visible ? "text" : "password"}
      slotProps={createPasswordVisibilitySlotProps(visible, setVisible)}
    />
  );
}
